import type { ComponentProps } from "react";

import { cn } from "@/lib/utils";

/** Card title — bold lead sentence followed by a grey-500 continuation.
 * Inter stylistic sets (ss01/ss02/ss03) come from the global `body` rule.
 * `className` carries the Figma "W Fixed" lede width so the wrap holds on
 * viewports wider than the 1440 design (cards otherwise grow and reflow it). */
export function CardLede({
  lead,
  rest,
  className,
  ...props
}: {
  lead: string;
  rest: string;
  className?: string;
} & ComponentProps<"p">) {
  return (
    <p
      className={cn(
        "text-grey-950 text-[18px] leading-[1.3] tracking-[-0.02em]",
        className
      )}
      {...props}
    >
      <span className="font-medium">{lead}</span>{" "}
      <span className="text-grey-500">{rest}</span>
    </p>
  );
}
